export default {
  "arabic": {
    "widget": {
      "text": "قائمة الوصول"
    },
    "reset_button": {
      "text": "إعادة تعيين"
    },
    "hide_button": {
      "text": "إخفاء"
    },
    "mute_sound": {
      "text": "كتم الأصوات"
    },
    "hide_image": {
      "text": "إخفاء الصور"
    },
    "virtual_keyboard": {
      "text": "لوحة مفاتيح افتراضية"
    },
    "reading_guide": {
      "text": "دليل القراءة"
    },
    "reading_mask": {
      "text": "قناع القراءة"
    },
    "stop_animation": {
      "text": "إيقاف الرسوم المتحركة"
    },
    "highlight_hover": {
      "text": "تسليط الضوء عند التحوّل"
    },
    "highlight_focus": {
      "text": "تسليط الضوء على التركيز"
    },
    "black_cursor": {
      "text": "مؤشر أسود كبير"
    },
    "white_cursor": {
      "text": "مؤشر أبيض كبير"
    },
    "navigation_keys": {
      "text": "مفاتيح التصفح"
    },
    "tts": {
      "text": "النص إلى كلام"
    },
    "content_scaling": {
      "text": "تكبير المحتوى"
    },
    "font_sizing": {
      "text": "تحجيم الخط"
    },
    "line_height": {
      "text": "ارتفاع الخط"
    },
    "letter_spacing": {
      "text": "تباعد الأحرف"
    },
    "text_magnifier": {
      "text": "مكبر النص"
    },
    "readable_font": {
      "text": "خط قابل للقراءة"
    },
    "dyslexia_friendly": {
      "text": "صديق لمن يعانون من العسر القرائي"
    },
    "highlight_titles": {
      "text": "تسليط الضوء على العناوين"
    },
    "highlight_links": {
      "text": "تسليط الضوء على الروابط"
    },
    "center_aligned": {
      "text": "محاذاة في الوسط"
    },
    "left_aligned": {
      "text": "محاذاة إلى اليسار"
    },
    "right_aligned": {
      "text": "محاذاة إلى اليمين"
    },
    "dark_contrast": {
      "text": "تباين داكن"
    },
    "light_contrast": {
      "text": "تباين فاتح"
    },
    "monochrome": {
      "text": "أبيض وأسود"
    },
    "high_contrast": {
      "text": "تباين عالي"
    },
    "high_saturation": {
      "text": "تشبع عالي"
    },
    "low_saturation": {
      "text": "تشبع منخفض"
    },
    "adjust_text_color": {
      "text": "ضبط لون النص"
    },
    "adjust_title_color": {
      "text": "ضبط ألوان العناوين"
    },
    "adjust_background_color": {
      "text": "ضبط ألوان الخلفية"
    },
    "default": {
      "text": "افتراضي"
    },
    "off": {
      "text": "إيقاف"
    },
    "on": {
      "text": "تشغيل"
    },
    "epilepsy": {
      "title": "وضع آمن للصرع",
      "subtitle": "يخفف من الألوان ويزيل الومضات",
      "description": "يتيح هذا الوضع للأشخاص الذين يعانون من الصرع استخدام الموقع بأمان من خلال القضاء على خطر النوبات الناتجة عن الرسوم المتحركة المتواجدة في الموقع والتوازي اللوني الخطير."
    },
    "visually_impaired": {
      "title": "وضع لضعاف البصر",
      "subtitle": "يحسن مظهر الموقع",
      "description": "يقوم هذا الوضع بضبط الموقع لراحة المستخدمين الذين يعانون من ضعف البصر مثل تدهور الرؤية، الرؤية الضيقة، الساد، الزرق، وغيرها."
    },
    "cognitive_disability": {
      "title": "وضع لضعاف التفكير",
      "subtitle": "يساعد على التركيز على المحتوى المعين",
      "description": "يوفر هذا الوضع خيارات مساعدة مختلفة لمساعدة المستخدمين الذين يعانون من إعاقات عقلية مثل الدسلكسيا، التوحد، الجلطة الدماغية، وغيرها، للتركيز بسهولة على العناصر الأساسية في الموقع."
    },
    "adhd_friendly": {
      "title": "وضع ملائم لمرضى فرط الحركة ونقص الانتباه (ADHD)",
      "subtitle": "يقلل من التشتت ويعزز التركيز",
      "description": "يساعد هذا الوضع المستخدمين الذين يعانون من ADHD واضطرابات النمو العصبي في القراءة وتصفح الموقع والتركيز على العناصر الرئيسية في الموقع بسهولة بينما يقلل بشكل كبير من التشتت."
    },
    "blindness": {
      "title": "وضع للعمى",
      "subtitle": "يسمح باستخدام الموقع مع قارئ الشاشة الخاص بك",
      "description": "يكون هذا الوضع متوافقًا مع قراء الشاشة مثل JAWS وNVDA وVoiceOver وTalkBack. قارئ الشاشة هو برنامج للمستخدمين الكفيفين يتم تثبيته على الكمبيوتر والهاتف الذكي، ويجب أن تكون المواقع متوافقة معه."
    }
  },
  "bengali": {
    "widget": {
      "text": "বাংধ্যতা মেনু"
    },
    "reset_button": {
      "text": "রিসেট"
    },
    "hide_button": {
      "text": "লুকান"
    },
    "mute_sound": {
      "text": "শব্দ শান্ত"
    },
    "hide_image": {
      "text": "চিত্র লুকাও"
    },
    "virtual_keyboard": {
      "text": "মানসিক কীবোর্ড"
    },
    "reading_guide": {
      "text": "পঠন গাইড"
    },
    "reading_mask": {
      "text": "পঠন মাস্ক"
    },
    "stop_animation": {
      "text": "অ্যানিমেশন বন্ধ"
    },
    "highlight_hover": {
      "text": "হাইলাইট হোভার"
    },
    "highlight_focus": {
      "text": "হাইলাইট ফোকাস"
    },
    "black_cursor": {
      "text": "বড় কালো কার্সার"
    },
    "white_cursor": {
      "text": "বড় সাদা কার্সার"
    },
    "navigation_keys": {
      "text": "নেভিগেশন কী"
    },
    "tts": {
      "text": "টেক্সট টু স্পিচ"
    },
    "content_scaling": {
      "text": "কন্টেন্ট স্কেলিং"
    },
    "font_sizing": {
      "text": "ফন্ট সাইজিং"
    },
    "line_height": {
      "text": "লাইন উচ্চতা"
    },
    "letter_spacing": {
      "text": "অক্ষর ফাঁক"
    },
    "text_magnifier": {
      "text": "টেক্সট বড় করা"
    },
    "readable_font": {
      "text": "পঠনযোগ্য ফন্ট"
    },
    "dyslexia_friendly": {
      "text": "ডাইসলেকসিয়া বন্ধুত্বপূর্ণ"
    },
    "highlight_titles": {
      "text": "শিরোনাম হাইলাইট"
    },
    "highlight_links": {
      "text": "লিঙ্ক হাইলাইট"
    },
    "center_aligned": {
      "text": "মধ্য সারিতে"
    },
    "left_aligned": {
      "text": "বাম সারিতে"
    },
    "right_aligned": {
      "text": "ডান সারিতে"
    },
    "dark_contrast": {
      "text": "গাঢ় বীমভাষ"
    },
    "light_contrast": {
      "text": "আলো বীমভাষ"
    },
    "monochrome": {
      "text": "মনোক্রোম"
    },
    "high_contrast": {
      "text": "উচ্চ বীমভাষ"
    },
    "high_saturation": {
      "text": "উচ্চ সজীবতা"
    },
    "low_saturation": {
      "text": "নিম্ন সজীবতা"
    },
    "adjust_text_color": {
      "text": "টেক্সট রঙ সাজাও"
    },
    "adjust_title_color": {
      "text": "শিরোনাম রঙ সাজাও"
    },
    "adjust_background_color": {
      "text": "পৃষ্ঠভূমি রঙ সাজাও"
    },
    "default": {
      "text": "ডিফল্ট"
    },
    "off": {
      "text": "বন্ধ"
    },
    "on": {
      "text": "চালু"
    },
    "epilepsy": {
      "title": "এপিলেপ্সি সেফ মোড",
      "subtitle": "রঙ শান্ত করে এবং ব্লিঙ্ক অপসারণ করে",
      "description": "এই মোড এপিলেপসির সমস্যা সৃষ্টি করা সাবধান অবস্থা থেকে সুরক্ষিতভাবে ওয়েবসাইট ব্যবহার করতে সহায়ক, যে যে জটিল রঙের সমমিশ্রণ এবং ব্লিঙ্কিং এনিমেশন থেকে আসা যায়।"
    },
    "visually_impaired": {
      "title": "দৃষ্টি দুর্বল মোড",
      "subtitle": "ওয়েবসাইটের দর্শনের সুধ করে",
      "description": "এই মোড দৃষ্টি দুর্বল ব্যবহারকারীদের জন্য ওয়েবসাইটটি সুবিধাসহকরণে পরিচিত হয়, যেমন দৃষ্টির ক্ষয়, টানেল ভিশন, ক্যাটার্যাক্ট, গ্লুকোমা, এবং অন্যান্য।"
    },
    "cognitive_disability": {
      "title": "মানসিক অক্ষমতা মোড",
      "subtitle": "নির্দিষ্ট বিষয়ে কেন্দ্রিকতা দেয়",
      "description": "এই মোড মানসিক অক্ষমতা যেমন ডিসলেক্সিয়া, অটিজম, CVA, এবং অন্যান্য মানসিক অসুখে যারা ওয়েবসাইটের গুরুত্বপূর্ণ উপাদানগুলি সহ সুবিধাসহকরণের জন্য বিভিন্ন সাহায্যক পক্ষ সরবরাহ করে।"
    },
    "adhd_friendly": {
      "title": "ADHD বন্ধুপ্রিয় মোড",
      "subtitle": "বিচ্ছিন্নতা হ্রাস এবং কেন্দ্রিকতা উন্নত করে",
      "description": "এই মোড ADHD এবং নিউরোডেভেলপমেন্টাল অসুখে যারা পুরস্কৃতি কমাত্রন পড়ে, পড়তে, ব্রাউজ করতে, এবং মূল ওয়েবসাইটের উপাদানের উপর কেন্দ্রিত হতে সহায়ক হয় এবং উপাদানগুলির চেয়ে স্পষ্টভাবে চ্ছাদন করে।"
    },
    "blindness": {
      "title": "নেত্র অন্ধতা মোড",
      "subtitle": "আপনার স্ক্রিন-রিডার দিয়ে সাইট ব্যবহার করার অনুমতি দেয়",
      "description": "এই মোড স্ক্রিন-রিডার যেমন JAWS, NVDA, VoiceOver, এবং TalkBack সাথে সামঞ্জস্যপূর্ণ ওয়েবসাইটের কনফিগারেশন করে। স্ক্রিন-রিডার হল কোনও কম্পিউটার এবং স্মার্টফোনে ইনস্টল করা একটি কোনও সময় নেত্র-দুর্বল ব্যবহারকারীর জন্য সফটওয়্যার, এবং ওয়েবসাইটগুলি এটের সাথে সমতুল্য হতে হয়।"
    },
    "search_wikipedia_dictionary": {
      "text": "উইকিপিডিয়া ডিকশনারি সার্চ করুন"
    }
  },
  "chinese": {
    "widget": {
      "text": "辅助菜单"
    },
    "reset_button": {
      "text": "重置"
    },
    "hide_button": {
      "text": "隐藏"
    },
    "mute_sound": {
      "text": "静音"
    },
    "hide_image": {
      "text": "隐藏图像"
    },
    "virtual_keyboard": {
      "text": "虚拟键盘"
    },
    "reading_guide": {
      "text": "阅读指南"
    },
    "reading_mask": {
      "text": "阅读模式"
    },
    "stop_animation": {
      "text": "停止动画"
    },
    "highlight_hover": {
      "text": "高亮悬停"
    },
    "highlight_focus": {
      "text": "高亮焦点"
    },
    "black_cursor": {
      "text": "大黑色光标"
    },
    "white_cursor": {
      "text": "大白色光标"
    },
    "navigation_keys": {
      "text": "导航键"
    },
    "tts": {
      "text": "文本转语音"
    },
    "content_scaling": {
      "text": "内容缩放"
    },
    "font_sizing": {
      "text": "字体大小"
    },
    "line_height": {
      "text": "行高"
    },
    "letter_spacing": {
      "text": "字母间距"
    },
    "text_magnifier": {
      "text": "文本放大器"
    },
    "readable_font": {
      "text": "易读字体"
    },
    "dyslexia_friendly": {
      "text": "识字障碍友好"
    },
    "highlight_titles": {
      "text": "标题高亮"
    },
    "highlight_links": {
      "text": "链接高亮"
    },
    "center_aligned": {
      "text": "居中对齐"
    },
    "left_aligned": {
      "text": "左对齐"
    },
    "right_aligned": {
      "text": "右对齐"
    },
    "dark_contrast": {
      "text": "深色对比度"
    },
    "light_contrast": {
      "text": "浅色对比度"
    },
    "monochrome": {
      "text": "单色模式"
    },
    "high_contrast": {
      "text": "高对比度"
    },
    "high_saturation": {
      "text": "高饱和度"
    },
    "low_saturation": {
      "text": "低饱和度"
    },
    "adjust_text_color": {
      "text": "调整文本颜色"
    },
    "adjust_title_color": {
      "text": "调整标题颜色"
    },
    "adjust_background_color": {
      "text": "调整背景颜色"
    },
    "default": {
      "text": "默认"
    },
    "off": {
      "text": "关闭"
    },
    "on": {
      "text": "打开"
    },
    "epilepsy": {
      "title": "癫痫安全模式",
      "subtitle": "减少颜色和消除闪烁",
      "description": "此模式通过消除闪烁或危险的颜色组合，使癫痫患者能够安全使用网站，减少癫痫发作的风险。"
    },
    "visually_impaired": {
      "title": "视力受损模式",
      "subtitle": "改善网站的视觉效果",
      "description": "此模式调整网站以方便视力受损的用户，如视力下降、视野狭窄、白内障、青光眼等。"
    },
    "cognitive_disability": {
      "title": "认知障碍模式",
      "subtitle": "帮助集中注意力在特定内容上",
      "description": "此模式提供不同的辅助选项，以帮助认知障碍患者，如阅读障碍、自闭症、脑血管意外等，更容易集中注意网站的重要元素。"
    },
    "adhd_friendly": {
      "title": "ADHD友好模式",
      "subtitle": "减少干扰，提高专注力",
      "description": "此模式帮助ADHD和神经发育障碍的用户更轻松地阅读、浏览和专注于主要网站元素，显著减少干扰。"
    },
    "blindness": {
      "title": "盲人模式",
      "subtitle": "允许使用屏幕阅读器",
      "description": "此模式配置网站以兼容屏幕阅读器，如JAWS、NVDA、VoiceOver和TalkBack。屏幕阅读器是为盲人用户设计的软件，安装在计算机和智能手机上，网站必须与之兼容。"
    },
    "search_wikipedia_dictionary": {
      "text": "搜索维基百科词典"
    }
  },
  "dutch": {
    "widget": {
      "text": "Toegankelijkheidsmenu"
    },
    "reset_button": {
      "text": "Reset"
    },
    "hide_button": {
      "text": "Verbergen"
    },
    "mute_sound": {
      "text": "Geluid dempen"
    },
    "hide_image": {
      "text": "Afbeeldingen verbergen"
    },
    "virtual_keyboard": {
      "text": "Virtueel toetsenbord"
    },
    "reading_guide": {
      "text": "Leesgids"
    },
    "reading_mask": {
      "text": "Leesmasker"
    },
    "stop_animation": {
      "text": "Animaties stoppen"
    },
    "highlight_hover": {
      "text": "Markeer bij aanwijzen"
    },
    "highlight_focus": {
      "text": "Markeer bij focus"
    },
    "black_cursor": {
      "text": "Grote zwarte cursor"
    },
    "white_cursor": {
      "text": "Grote witte cursor"
    },
    "navigation_keys": {
      "text": "Navigatietoetsen"
    },
    "tts": {
      "text": "Tekst naar spraak"
    },
    "content_scaling": {
      "text": "Inhoudsschaal"
    },
    "font_sizing": {
      "text": "Lettergrootte"
    },
    "line_height": {
      "text": "Regelafstand"
    },
    "letter_spacing": {
      "text": "Letterafstand"
    },
    "text_magnifier": {
      "text": "Tekstvergroter"
    },
    "readable_font": {
      "text": "Leesbaar lettertype"
    },
    "dyslexia_friendly": {
      "text": "Dyslexievriendelijk"
    },
    "highlight_titles": {
      "text": "Markeer titels"
    },
    "highlight_links": {
      "text": "Markeer koppelingen"
    },
    "center_aligned": {
      "text": "Gecentreerd uitgelijnd"
    },
    "left_aligned": {
      "text": "Links uitgelijnd"
    },
    "right_aligned": {
      "text": "Rechts uitgelijnd"
    },
    "dark_contrast": {
      "text": "Donker contrast"
    },
    "light_contrast": {
      "text": "Licht contrast"
    },
    "monochrome": {
      "text": "Monochroom"
    },
    "high_contrast": {
      "text": "Hoog contrast"
    },
    "high_saturation": {
      "text": "Hoge verzadiging"
    },
    "low_saturation": {
      "text": "Lage verzadiging"
    },
    "adjust_text_color": {
      "text": "Tekstkleur aanpassen"
    },
    "adjust_title_color": {
      "text": "Titelkleuren aanpassen"
    },
    "adjust_background_color": {
      "text": "Achtergrondkleuren aanpassen"
    },
    "default": {
      "text": "Standaard"
    },
    "off": {
      "text": "UIT"
    },
    "on": {
      "text": "AAN"
    },
    "epilepsy": {
      "title": "Epilepsieveilige modus",
      "subtitle": "Verzacht kleuren en verwijdert knipperingen",
      "description": "Deze modus maakt het mogelijk voor mensen met epilepsie om de website veilig te gebruiken door het elimineren van het risico op aanvallen die worden veroorzaakt door knipperende animaties en risicovolle kleurcombinaties."
    },
    "visually_impaired": {
      "title": "Visueel beperkte modus",
      "subtitle": "Verbeter de visuele weergave van de website",
      "description": "Deze modus past de website aan voor het gemak van gebruikers met visuele beperkingen zoals slechtziendheid, tunnelzicht, staar, glaucoom en anderen."
    },
    "cognitive_disability": {
      "title": "Modus voor cognitieve beperkingen",
      "subtitle": "Helpt bij het focussen op specifieke inhoud",
      "description": "Deze modus biedt verschillende hulpmiddelen om gebruikers met cognitieve beperkingen zoals dyslexie, autisme, CVA en anderen te helpen zich gemakkelijker te concentreren op de essentiële elementen van de website."
    },
    "adhd_friendly": {
      "title": "ADHD-vriendelijke modus",
      "subtitle": "Vermindert afleiding en verbetert de focus",
      "description": "Deze modus helpt gebruikers met ADHD en neurodevelopmentale stoornissen om gemakkelijker te lezen, te browsen en zich te concentreren op de belangrijkste elementen van de website, terwijl afleiding aanzienlijk wordt verminderd."
    },
    "blindness": {
      "title": "Blindenmodus",
      "subtitle": "Maakt gebruik van de website met uw schermlezer mogelijk",
      "description": "Deze modus configureert de website zodat deze compatibel is met schermlezers zoals JAWS, NVDA, VoiceOver en TalkBack. Een schermlezer is software voor blinde gebruikers die is geïnstalleerd op een computer en smartphone, en websites moeten compatibel zijn met deze software."
    },
    "search_wikipedia_dictionary": {
      "text": "Zoek in de Wikipedia-woordenboek"
    }
  },
  "english": {
    "widget": {
      "text": "Accessibility Menu"
    },
    "reset_button": {
      "text": "Reset"
    },
    "hide_button": {
      "text": "Hide"
    },
    "mute_sound": {
      "text": "Mute Sounds"
    },
    "hide_image": {
      "text": "Hide Images"
    },
    "virtual_keyboard": {
      "text": "Virtual Keyboard"
    },
    "reading_guide": {
      "text": "Reading Guide"
    },
    "reading_mask": {
      "text": "Reading Mask"
    },
    "stop_animation": {
      "text": "Stop Animations"
    },
    "highlight_hover": {
      "text": "Highlight Hover"
    },
    "highlight_focus": {
      "text": "Highlight Focus"
    },
    "black_cursor": {
      "text": "Big Black Cursor"
    },
    "white_cursor": {
      "text": "Big White Cursor"
    },
    "navigation_keys": {
      "text": "Navigation Keys"
    },
    "tts": {
      "text": "Text to Speech"
    },
    "content_scaling": {
      "text": "Content Scaling"
    },
    "font_sizing": {
      "text": "Font Sizing"
    },
    "line_height": {
      "text": "Line Height"
    },
    "letter_spacing": {
      "text": "Letter Spacing"
    },
    "text_magnifier": {
      "text": "Text Magnifier"
    },
    "readable_font": {
      "text": "Readable Font"
    },
    "dyslexia_friendly": {
      "text": "Dyslexia Friendly"
    },
    "highlight_titles": {
      "text": "Highlight Titles"
    },
    "highlight_links": {
      "text": "Highlight Links"
    },
    "center_aligned": {
      "text": "Center Aligned"
    },
    "left_aligned": {
      "text": "Left Aligned"
    },
    "right_aligned": {
      "text": "right_aligned"
    },
    "dark_contrast": {
      "text": "Dark Contrast"
    },
    "light_contrast": {
      "text": "Light Contrast"
    },
    "monochrome": {
      "text": "Monochrome"
    },
    "high_contrast": {
      "text": "High Contrast"
    },
    "high_saturation": {
      "text": "High Saturation"
    },
    "low_saturation": {
      "text": "Low Saturation"
    },
    "adjust_text_color": {
      "text": "Adjust Text Color"
    },
    "adjust_title_color": {
      "text": "Adjust Title Colors"
    },
    "adjust_background_color": {
      "text": "Adjust Background Colors"
    },
    "default": {
      "text": "default"
    },
    "off": {
      "text": "OFF"
    },
    "on": {
      "text": "ON"
    },
    "epilepsy": {
      "title": "Epilepsy Safe Mode",
      "subtitle": "Dampens color and removes blinks",
      "description": "This mode enables people with epilepsy to use the website safely by eliminating the risk of seizures that result from flashing or blinking animations and risky color combinations."
    },
    "visually_impaired": {
      "title": "Visually Impaired Mode",
      "subtitle": "Improves website's visuals",
      "description": "This mode adjusts the website for the convenience of users with visual impairments such as Degrading Eyesight, Tunnel Vision, Cataract, Glaucoma, and others."
    },
    "cognitive_disability": {
      "title": "Cognitive Disability Mode",
      "subtitle": "Helps to focus on specific content",
      "description": "This mode provides different assistive options to help users with cognitive impairments such as Dyslexia, Autism, CVA, and others, to focus on the essential elements of the website more easily."
    },
    "adhd_friendly": {
      "title": "ADHD Friendly Mode",
      "subtitle": "Reduces distractions and improve focus",
      "description": "This mode helps users with ADHD and Neurodevelopmental disorders to read, browse, and focus on the main website elements more easily while significantly reducing distractions."
    },
    "blindness": {
      "title": "Blindness Mode",
      "subtitle": "Allows using the site with your screen-reader",
      "description": "This mode configures the website to be compatible with screen-readers such as JAWS, NVDA, VoiceOver, and TalkBack. A screen-reader is software for blind users that is installed on a computer and smartphone, and websites must be compatible with it."
    },
    "search_wikipedia_dictionary": {
      "text": "Search Wikipedia Dictionary"
    }
  },
  "french": {
    "widget": {
      "text": "Menu d'accessibilité"
    },
    "reset_button": {
      "text": "Réinitialiser"
    },
    "hide_button": {
      "text": "Cacher"
    },
    "mute_sound": {
      "text": "Couper le son"
    },
    "hide_image": {
      "text": "Cacher les images"
    },
    "virtual_keyboard": {
      "text": "Clavier virtuel"
    },
    "reading_guide": {
      "text": "Guide de lecture"
    },
    "reading_mask": {
      "text": "Masque de lecture"
    },
    "stop_animation": {
      "text": "Arrêter les animations"
    },
    "highlight_hover": {
      "text": "Surligner survol"
    },
    "highlight_focus": {
      "text": "Surligner la mise au point"
    },
    "black_cursor": {
      "text": "Gros curseur noir"
    },
    "white_cursor": {
      "text": "Gros curseur blanc"
    },
    "navigation_keys": {
      "text": "Touches de navigation"
    },
    "tts": {
      "text": "Synthèse vocale"
    },
    "content_scaling": {
      "text": "Mise à l'échelle du contenu"
    },
    "font_sizing": {
      "text": "Taille de police"
    },
    "line_height": {
      "text": "Hauteur de ligne"
    },
    "letter_spacing": {
      "text": "Espacement des lettres"
    },
    "text_magnifier": {
      "text": "Loupes de texte"
    },
    "readable_font": {
      "text": "Police lisible"
    },
    "dyslexia_friendly": {
      "text": "Convivialité pour les dyslexiques"
    },
    "highlight_titles": {
      "text": "Surligner les titres"
    },
    "highlight_links": {
      "text": "Surligner les liens"
    },
    "center_aligned": {
      "text": "Aligné au centre"
    },
    "left_aligned": {
      "text": "Aligné à gauche"
    },
    "right_aligned": {
      "text": "Aligné à droite"
    },
    "dark_contrast": {
      "text": "Contraste élevé"
    },
    "light_contrast": {
      "text": "Contraste faible"
    },
    "monochrome": {
      "text": "Monochrome"
    },
    "high_contrast": {
      "text": "Contraste élevé"
    },
    "high_saturation": {
      "text": "Saturation élevée"
    },
    "low_saturation": {
      "text": "Saturation faible"
    },
    "adjust_text_color": {
      "text": "Ajuster la couleur du texte"
    },
    "adjust_title_color": {
      "text": "Ajuster la couleur des titres"
    },
    "adjust_background_color": {
      "text": "Ajuster la couleur de l'arrière-plan"
    },
    "default": {
      "text": "Par défaut"
    },
    "off": {
      "text": "Désactivé"
    },
    "on": {
      "text": "Activé"
    },
    "epilepsy": {
      "title": "Mode Sécurité Épilepsie",
      "subtitle": "Atténue les couleurs et supprime les clignotements",
      "description": "Ce mode permet aux personnes épileptiques d'utiliser le site en toute sécurité en éliminant le risque de crises provoquées par des animations clignotantes ou des combinaisons de couleurs risquées."
    },
    "visually_impaired": {
      "title": "Mode pour Personnes Malvoyantes",
      "subtitle": "Améliore l'aspect visuel du site",
      "description": "Ce mode ajuste le site pour le confort des utilisateurs ayant des problèmes de vision, tels que la baisse de la vision, la vision en tunnel, la cataracte, le glaucome et d'autres."
    },
    "cognitive_disability": {
      "title": "Mode pour Personnes avec Handicap Cognitif",
      "subtitle": "Facilite la concentration sur un contenu spécifique",
      "description": "Ce mode propose différentes options d'assistance pour aider les utilisateurs souffrant de troubles cognitifs, tels que la dyslexie, l'autisme, les AVC, et d'autres, à se concentrer plus facilement sur les éléments essentiels du site."
    },
    "adhd_friendly": {
      "title": "Mode Convivial pour l'ADHD",
      "subtitle": "Réduit les distractions et améliore la concentration",
      "description": "Ce mode aide les utilisateurs atteints de TDAH et de troubles du développement neurologique à lire, naviguer et se concentrer plus facilement sur les principaux éléments du site tout en réduisant considérablement les distractions."
    },
    "blindness": {
      "title": "Mode pour les Aveugles",
      "subtitle": "Permet d'utiliser le site avec votre lecteur d'écran",
      "description": "Ce mode configure le site pour qu'il soit compatible avec les lecteurs d'écran tels que JAWS, NVDA, VoiceOver et TalkBack. Un lecteur d'écran est un logiciel pour les utilisateurs aveugles installé sur un ordinateur et un smartphone, et les sites Web doivent être compatibles avec lui."
    },
    "search_wikipedia_dictionary": {
      "text": "Rechercher dans le dictionnaire Wikipedia"
    }
  },
  "german": {
    "widget": {
      "text": "Barrierefreiheitsmenü"
    },
    "reset_button": {
      "text": "Zurücksetzen"
    },
    "hide_button": {
      "text": "Verbergen"
    },
    "mute_sound": {
      "text": "Ton Stummschalten"
    },
    "hide_image": {
      "text": "Bilder ausblenden"
    },
    "virtual_keyboard": {
      "text": "Virtuelle Tastatur"
    },
    "reading_guide": {
      "text": "Leseanleitung"
    },
    "reading_mask": {
      "text": "Lesemaske"
    },
    "stop_animation": {
      "text": "Animationen stoppen"
    },
    "highlight_hover": {
      "text": "Hervorhebung beim Hovern"
    },
    "highlight_focus": {
      "text": "Hervorhebung beim Fokus"
    },
    "black_cursor": {
      "text": "Großer schwarzer Cursor"
    },
    "white_cursor": {
      "text": "Großer weißer Cursor"
    },
    "navigation_keys": {
      "text": "Navigations-Tasten"
    },
    "tts": {
      "text": "Text-zu-Sprache"
    },
    "content_scaling": {
      "text": "Inhaltsanpassung"
    },
    "font_sizing": {
      "text": "Schriftgröße"
    },
    "line_height": {
      "text": "Zeilenabstand"
    },
    "letter_spacing": {
      "text": "Buchstabenabstand"
    },
    "text_magnifier": {
      "text": "Textvergrößerung"
    },
    "readable_font": {
      "text": "Leicht lesbare Schrift"
    },
    "dyslexia_friendly": {
      "text": "Dyslexie-freundlich"
    },
    "highlight_titles": {
      "text": "Überschriften hervorheben"
    },
    "highlight_links": {
      "text": "Links hervorheben"
    },
    "center_aligned": {
      "text": "Zentrierte Ausrichtung"
    },
    "left_aligned": {
      "text": "Links ausgerichtet"
    },
    "right_aligned": {
      "text": "Rechts ausgerichtet"
    },
    "dark_contrast": {
      "text": "Dunkler Kontrast"
    },
    "light_contrast": {
      "text": "Heller Kontrast"
    },
    "monochrome": {
      "text": "Monochrom"
    },
    "high_contrast": {
      "text": "Hoher Kontrast"
    },
    "high_saturation": {
      "text": "Hohe Sättigung"
    },
    "low_saturation": {
      "text": "Niedrige Sättigung"
    },
    "adjust_text_color": {
      "text": "Textfarbe anpassen"
    },
    "adjust_title_color": {
      "text": "Titelfarben anpassen"
    },
    "adjust_background_color": {
      "text": "Hintergrundfarben anpassen"
    },
    "default": {
      "text": "Standard"
    },
    "off": {
      "text": "AUS"
    },
    "on": {
      "text": "EIN"
    },
    "epilepsy": {
      "title": "Epilepsiesicherer Modus",
      "subtitle": "Reduziert Farben und blendende Effekte",
      "description": "Dieser Modus ermöglicht Menschen mit Epilepsie die sichere Nutzung der Website, indem er das Risiko von Anfällen durch flackernde Animationen und riskante Farbkombinationen minimiert."
    },
    "visually_impaired": {
      "title": "Modus für Sehbehinderte",
      "subtitle": "Verbessert die Darstellung der Website",
      "description": "Dieser Modus passt die Website für die Bequemlichkeit von Nutzern mit Sehbeeinträchtigungen wie Sehschwäche, Gesichtsfeldeinschränkung, Katarakt, Glaukom und anderen an."
    },
    "cognitive_disability": {
      "title": "Modus für kognitive Beeinträchtigungen",
      "subtitle": "Hilft bei der Fokussierung auf spezifische Inhalte",
      "description": "Dieser Modus bietet verschiedene Unterstützungsoptionen, um Nutzern mit kognitiven Beeinträchtigungen wie Legasthenie, Autismus, Schlaganfall (CVA) und anderen zu helfen, sich leichter auf die wesentlichen Elemente der Website zu konzentrieren."
    },
    "adhd_friendly": {
      "title": "ADHS-freundlicher Modus",
      "subtitle": "Reduziert Ablenkungen und verbessert die Konzentration",
      "description": "Dieser Modus unterstützt Nutzer mit ADHS und neurologischen Entwicklungsstörungen dabei, einfacher zu lesen, zu browsen und sich auf die Hauptelemente der Website zu konzentrieren, während Ablenkungen deutlich verringert werden."
    },
    "blindness": {
      "title": "Blindenmodus",
      "subtitle": "Ermöglicht die Nutzung der Website mit Ihrem Bildschirmleseprogramm",
      "description": "Dieser Modus konfiguriert die Website, damit sie mit Bildschirmleseprogrammen wie JAWS, NVDA, VoiceOver und TalkBack kompatibel ist. Ein Bildschirmleseprogramm ist eine Software für blinde Benutzer, die auf einem Computer und Smartphone installiert ist, und Websites müssen damit kompatibel sein."
    },
    "search_wikipedia_dictionary": {
      "text": "Wikipedia-Wörterbuch durchsuchen"
    }
  },
  "hindi": {
    "widget": {
      "text": "पहुँचीयता मेनू"
    },
    "reset_button": {
      "text": "रीसेट"
    },
    "hide_button": {
      "text": "छिपाएं"
    },
    "mute_sound": {
      "text": "ध्वनि म्यूट करें"
    },
    "hide_image": {
      "text": "छवियाँ छिपाएं"
    },
    "virtual_keyboard": {
      "text": "आभासी कीबोर्ड"
    },
    "reading_guide": {
      "text": "पठन मार्गदर्शन"
    },
    "reading_mask": {
      "text": "पठन मास्क"
    },
    "stop_animation": {
      "text": "एनिमेशन बंद करें"
    },
    "highlight_hover": {
      "text": "हाइलाइट होवर"
    },
    "highlight_focus": {
      "text": "हाइलाइट फोकस"
    },
    "black_cursor": {
      "text": "बड़ा काला कर्सर"
    },
    "white_cursor": {
      "text": "बड़ा सफेद कर्सर"
    },
    "navigation_keys": {
      "text": "नेविगेशन कुंजी"
    },
    "tts": {
      "text": "टेक्स्ट से बोलना"
    },
    "content_scaling": {
      "text": "सामग्री मितान"
    },
    "font_sizing": {
      "text": "फॉन्ट आकार"
    },
    "line_height": {
      "text": "रेखा उचाई"
    },
    "letter_spacing": {
      "text": "पत्र खाली"
    },
    "text_magnifier": {
      "text": "टेक्स्ट बड़ा करने वाला"
    },
    "readable_font": {
      "text": "पठन योग्य फॉन्ट"
    },
    "dyslexia_friendly": {
      "text": "डिस्लेक्सिया योग्य"
    },
    "highlight_titles": {
      "text": "शीर्षक हाइलाइट"
    },
    "highlight_links": {
      "text": "लिंक हाइलाइट"
    },
    "center_aligned": {
      "text": "केंद्रित संरेखित"
    },
    "left_aligned": {
      "text": "बांये संरेखित"
    },
    "right_aligned": {
      "text": "दांये संरेखित"
    },
    "dark_contrast": {
      "text": "अंधेरा प्रतिरोध"
    },
    "light_contrast": {
      "text": "प्रकाश प्रतिरोध"
    },
    "monochrome": {
      "text": "मोनोक्रोम"
    },
    "high_contrast": {
      "text": "उच्च प्रतिरोध"
    },
    "high_saturation": {
      "text": "उच्च अधिकरण"
    },
    "low_saturation": {
      "text": "न्यून अधिकरण"
    },
    "adjust_text_color": {
      "text": "टेक्स्ट रंग समायोजन"
    },
    "adjust_title_color": {
      "text": "शीर्षक रंग समायोजन"
    },
    "adjust_background_color": {
      "text": "पृष्ठभूमि रंग समायोजन"
    },
    "default": {
      "text": "मूल"
    },
    "off": {
      "text": "बंद"
    },
    "on": {
      "text": "चालू"
    },
    "epilepsy": {
      "title": "मिर्गी सुरक्षित मोड",
      "subtitle": "रंगों को कम करता है और ब्लिंक हटाता है",
      "description": "इस मोड द्वारा मिर्गी वाले लोग वेबसाइट का सुरक्षित उपयोग कर सकते हैं जिससे फ्लैशिंग या ब्लिंकिंग एनिमेशन और जोखिमपूर्ण रंग संयोजन से होने वाले आक्रमणों का खतरा कम होता है।"
    },
    "visually_impaired": {
      "title": "दृष्टिविकलंपित मोड",
      "subtitle": "वेबसाइट के दृश्य को सुधारता है",
      "description": "इस मोड द्वारा वेबसाइट को उन उपयोगकर्ताओं के लिए सुझाया जाता है जिनकी दृष्टिशक्ति में कमी है, जैसे दृष्टिशक्ति कम होना, टनल विजन, कैटरैक्ट, ग्लूकोमा, और अन्य।"
    },
    "cognitive_disability": {
      "title": "मानसिक अक्षमता मोड",
      "subtitle": "विशिष्ट सामग्री पर ध्यान केंद्रित करने में मदद करता है",
      "description": "यह मोड मानसिक अक्षमता जैसे डिस्लेक्सिया, ऑटिज्म, सीवीए, और अन्य मानसिक अक्षमताओं वाले उपयोगकर्ताओं को वेबसाइट के महत्वपूर्ण घटकों पर आसानी से ध्यान केंद्रित करने के लिए विभिन्न सहायक विकल्प प्रदान करता है।"
    },
    "adhd_friendly": {
      "title": "एडीएचडी फ्रेंडली मोड",
      "subtitle": "बेहद ध्यान भटकाने और फोकस को बढ़ाता है",
      "description": "यह मोड एडीएचडी और न्यूरोडेवलपमेंटल विकारों वाले उपयोगकर्ताओं को प्रमुख वेबसाइट घटकों पर आसानी से पढ़ने, ब्राउज करने और ध्यान केंद्रित करने में मदद करता है, जबकि विशेषत: उत्तरोत्तर अधिक ध्यान विच्छेद रखते हुए विशेषत: उत्तरोत्तर अधिक ध्यान विच्छेद रखते हुए अफलाने दर्शक द्वारा ध्यान केंद्रित करने में मदद करता है।"
    },
    "blindness": {
      "title": "अंधापन मोड",
      "subtitle": "अपने स्क्रीन-रीडर के साथ साइट का उपयोग करने की अनुमति देता है",
      "description": "यह मोड स्क्रीन-रीडर जैसे JAWS, NVDA, VoiceOver और TalkBack के साथ संगत बनाने के लिए वेबसाइट को रूपांतरित करता है। एक स्क्रीन-रीडर क्या है, यह एक कंप्यूटर और स्मार्टफ़ोन पर स्थापित एक सॉफ़्टवेयर है, और वेबसाइट उसके साथ संगत होनी चाहिए जो दृष्टिशक्ति वाले उपयोगकर्ताओं के लिए होता है।"
    },
    "search_wikipedia_dictionary": {
      "text": "विकिपीडिया शब्दकोश खोजें"
    }
  },
  "italian": {
    "widget": {
      "text": "Menu di Accessibilità"
    },
    "reset_button": {
      "text": "Ripristina"
    },
    "hide_button": {
      "text": "Nascondi"
    },
    "mute_sound": {
      "text": "Silenzia Suoni"
    },
    "hide_image": {
      "text": "Nascondi Immagini"
    },
    "virtual_keyboard": {
      "text": "Tastiera Virtuale"
    },
    "reading_guide": {
      "text": "Guida alla Lettura"
    },
    "reading_mask": {
      "text": "Maschera di Lettura"
    },
    "stop_animation": {
      "text": "Arresta le Animazioni"
    },
    "highlight_hover": {
      "text": "Evidenzia il Passaggio del Mouse"
    },
    "highlight_focus": {
      "text": "Evidenzia il Focalizzazione"
    },
    "black_cursor": {
      "text": "Grande Cursore Nero"
    },
    "white_cursor": {
      "text": "Grande Cursore Bianco"
    },
    "navigation_keys": {
      "text": "Tasti di Navigazione"
    },
    "tts": {
      "text": "Lettura Vocale"
    },
    "content_scaling": {
      "text": "Ridimensionamento del Contenuto"
    },
    "font_sizing": {
      "text": "Dimensione del Carattere"
    },
    "line_height": {
      "text": "Interlinea"
    },
    "letter_spacing": {
      "text": "Spaziatura tra le Lettere"
    },
    "text_magnifier": {
      "text": "Ingrandimento del Testo"
    },
    "readable_font": {
      "text": "Carattere Leggibile"
    },
    "dyslexia_friendly": {
      "text": "Amico della Dislessia"
    },
    "highlight_titles": {
      "text": "Evidenzia i Titoli"
    },
    "highlight_links": {
      "text": "Evidenzia i Collegamenti"
    },
    "center_aligned": {
      "text": "Allineamento al Centro"
    },
    "left_aligned": {
      "text": "Allineamento a Sinistra"
    },
    "right_aligned": {
      "text": "Allineamento a Destra"
    },
    "dark_contrast": {
      "text": "Alto Contrasto Scuri"
    },
    "light_contrast": {
      "text": "Alto Contrasto Chiari"
    },
    "monochrome": {
      "text": "Monocromatico"
    },
    "high_contrast": {
      "text": "Alto Contrasto"
    },
    "high_saturation": {
      "text": "Alta Saturazione"
    },
    "low_saturation": {
      "text": "Bassa Saturazione"
    },
    "adjust_text_color": {
      "text": "Regola il Colore del Testo"
    },
    "adjust_title_color": {
      "text": "Regola i Colori dei Titoli"
    },
    "adjust_background_color": {
      "text": "Regola i Colori dello Sfondo"
    },
    "default": {
      "text": "Predefinito"
    },
    "off": {
      "text": "Spegnere"
    },
    "on": {
      "text": "Accendere"
    },
    "epilepsy": {
      "title": "Modalità Epilessia Sicura",
      "subtitle": "Attenua i colori e rimuove i lampeggi",
      "description": "Questa modalità consente alle persone con epilessia di utilizzare il sito web in sicurezza eliminando il rischio di crisi dovute a animazioni lampeggianti o combinazioni di colori rischiose."
    },
    "visually_impaired": {
      "title": "Modalità per Ipovedenti",
      "subtitle": "Migliora la visualizzazione del sito web",
      "description": "Questa modalità adatta il sito web per il comfort degli utenti con problemi visivi come la riduzione della vista, la visione a tunnel, la cataratta, il glaucoma e altri."
    },
    "cognitive_disability": {
      "title": "Modalità per Disabilità Cognitive",
      "subtitle": "Aiuta a concentrarsi su contenuti specifici",
      "description": "Questa modalità fornisce diverse opzioni di assistenza per aiutare gli utenti con disabilità cognitive come la dislessia, l'autismo, l'ictus (CVA) e altri a concentrarsi più facilmente sugli elementi essenziali del sito web."
    },
    "adhd_friendly": {
      "title": "Modalità ADHD Amichevole",
      "subtitle": "Riduce le distrazioni e migliora la concentrazione",
      "description": "Questa modalità aiuta gli utenti con ADHD e disturbi dello sviluppo neurologico a leggere, navigare e concentrarsi più facilmente sugli elementi principali del sito web, riducendo notevolmente le distrazioni."
    },
    "blindness": {
      "title": "Modalità per Non Vedenti",
      "subtitle": "Consente di utilizzare il sito con il lettore dello schermo",
      "description": "Questa modalità configura il sito web in modo da renderlo compatibile con lettori dello schermo come JAWS, NVDA, VoiceOver e TalkBack. Un lettore dello schermo è un software installato su un computer e uno smartphone per utenti non vedenti, e i siti web devono essere compatibili con esso."
    },
    "search_wikipedia_dictionary": {
      "text": "Cerca nel Dizionario Wikipedia"
    }
  },
  "japanese": {
    "widget": {
      "text": "アクセシビリティメニュー"
    },
    "reset_button": {
      "text": "リセット"
    },
    "hide_button": {
      "text": "非表示"
    },
    "mute_sound": {
      "text": "音声をミュート"
    },
    "hide_image": {
      "text": "画像非表示"
    },
    "virtual_keyboard": {
      "text": "仮想キーボード"
    },
    "reading_guide": {
      "text": "読書ガイド"
    },
    "reading_mask": {
      "text": "読書マスク"
    },
    "stop_animation": {
      "text": "アニメーション停止"
    },
    "highlight_hover": {
      "text": "ホバーハイライト"
    },
    "highlight_focus": {
      "text": "フォーカスハイライト"
    },
    "black_cursor": {
      "text": "大きな黒いカーソル"
    },
    "white_cursor": {
      "text": "大きな白いカーソル"
    },
    "navigation_keys": {
      "text": "ナビゲーションキー"
    },
    "tts": {
      "text": "テキスト読み上げ"
    },
    "content_scaling": {
      "text": "コンテンツ拡大縮小"
    },
    "font_sizing": {
      "text": "フォントサイズ"
    },
    "line_height": {
      "text": "行間"
    },
    "letter_spacing": {
      "text": "文字間隔"
    },
    "text_magnifier": {
      "text": "テキスト拡大鏡"
    },
    "readable_font": {
      "text": "読みやすいフォント"
    },
    "dyslexia_friendly": {
      "text": "ディスレクシア対応"
    },
    "highlight_titles": {
      "text": "タイトルハイライト"
    },
    "highlight_links": {
      "text": "リンクハイライト"
    },
    "center_aligned": {
      "text": "中央寄せ"
    },
    "left_aligned": {
      "text": "左寄せ"
    },
    "right_aligned": {
      "text": "右寄せ"
    },
    "dark_contrast": {
      "text": "ダークコントラスト"
    },
    "light_contrast": {
      "text": "ライトコントラスト"
    },
    "monochrome": {
      "text": "モノクローム"
    },
    "high_contrast": {
      "text": "ハイコントラスト"
    },
    "high_saturation": {
      "text": "高彩度"
    },
    "low_saturation": {
      "text": "低彩度"
    },
    "adjust_text_color": {
      "text": "テキスト色調整"
    },
    "adjust_title_color": {
      "text": "タイトル色調整"
    },
    "adjust_background_color": {
      "text": "背景色調整"
    },
    "default": {
      "text": "デフォルト"
    },
    "off": {
      "text": "オフ"
    },
    "on": {
      "text": "オン"
    },
    "epilepsy": {
      "title": "てんかん安全モード",
      "subtitle": "色調を抑えて点滅を除去",
      "description": "このモードは、てんかんを持つ人々が、点滅やリスクのある色の組み合わせから生じる発作のリスクを排除し、ウェブサイトを安全に利用するのを可能にします。"
    },
    "visually_impaired": {
      "title": "視覚障害者モード",
      "subtitle": "ウェブサイトの視覚的な表示を改善",
      "description": "このモードは視覚障害者、視野の狭窄、白内障、緑内障など視覚に障害のあるユーザーの利便性のためにウェブサイトを調整します。"
    },
    "cognitive_disability": {
      "title": "認知障害者モード",
      "subtitle": "特定のコンテンツに焦点を当てるのをサポート",
      "description": "このモードは、読解力の低下、自閉症、脳卒中などの認知障害を持つユーザーがウェブサイトの重要な要素に簡単に焦点を当てるためのさまざまな支援オプションを提供します。"
    },
    "adhd_friendly": {
      "title": "ADHDフレンドリーモード",
      "subtitle": "気を散らす要因を減少し、集中力を向上",
      "description": "このモードは、ADHDや神経発達障害のユーザーが、主要なウェブサイトの要素に簡単にアクセスできるようにし、かつ気を散らす要因を大幅に削減します。"
    },
    "blindness": {
      "title": "視覚障害者モード",
      "subtitle": "画面読み上げソフトを使用してサイトを利用",
      "description": "このモードは、JAWS、NVDA、VoiceOver、TalkBackなどの画面読み上げソフトと互換性のあるようにウェブサイトを設定します。画面読み上げソフトは視覚障害者向けのコンピュータやスマートフォンにインストールされるソフトウェアで、ウェブサイトはこれと互換性が必要です。"
    },
    "search_wikipedia_dictionary": {
      "text": "ウィキペディア辞書を検索"
    }
  },
  "korean": {
    "widget": {
      "text": "접근성 메뉴"
    },
    "reset_button": {
      "text": "초기화"
    },
    "hide_button": {
      "text": "숨기기"
    },
    "mute_sound": {
      "text": "소리 음소거"
    },
    "hide_image": {
      "text": "이미지 숨기기"
    },
    "virtual_keyboard": {
      "text": "가상 키보드"
    },
    "reading_guide": {
      "text": "독해 안내"
    },
    "reading_mask": {
      "text": "독해 마스크"
    },
    "stop_animation": {
      "text": "애니메이션 중지"
    },
    "highlight_hover": {
      "text": "마우스 오버 강조"
    },
    "highlight_focus": {
      "text": "포커스 강조"
    },
    "black_cursor": {
      "text": "큰 검은 커서"
    },
    "white_cursor": {
      "text": "큰 흰 커서"
    },
    "navigation_keys": {
      "text": "네비게이션 키"
    },
    "tts": {
      "text": "텍스트 음성 변환"
    },
    "content_scaling": {
      "text": "컨텐츠 확대/축소"
    },
    "font_sizing": {
      "text": "글꼴 크기"
    },
    "line_height": {
      "text": "행간"
    },
    "letter_spacing": {
      "text": "글자 간격"
    },
    "text_magnifier": {
      "text": "텍스트 확대기"
    },
    "readable_font": {
      "text": "가독성 있는 글꼴"
    },
    "dyslexia_friendly": {
      "text": "실해장애자 친화적"
    },
    "highlight_titles": {
      "text": "제목 강조"
    },
    "highlight_links": {
      "text": "링크 강조"
    },
    "center_aligned": {
      "text": "가운데 정렬"
    },
    "left_aligned": {
      "text": "왼쪽 정렬"
    },
    "right_aligned": {
      "text": "오른쪽 정렬"
    },
    "dark_contrast": {
      "text": "어두운 대비"
    },
    "light_contrast": {
      "text": "밝은 대비"
    },
    "monochrome": {
      "text": "모노크롬"
    },
    "high_contrast": {
      "text": "높은 대비"
    },
    "high_saturation": {
      "text": "높은 채도"
    },
    "low_saturation": {
      "text": "낮은 채도"
    },
    "adjust_text_color": {
      "text": "텍스트 색상 조정"
    },
    "adjust_title_color": {
      "text": "제목 색상 조정"
    },
    "adjust_background_color": {
      "text": "배경 색상 조정"
    },
    "default": {
      "text": "기본"
    },
    "off": {
      "text": "끄기"
    },
    "on": {
      "text": "켜기"
    },
    "epilepsy": {
      "title": "간질 안전 모드",
      "subtitle": "색상을 감소시키고 깜박임을 제거합니다",
      "description": "이 모드는 깜박이거나 위험한 색상 조합으로 인한 발작 위험을 제거하여 간질을 가진 사람들이 웹 사이트를 안전하게 사용할 수 있도록 합니다."
    },
    "visually_impaired": {
      "title": "시각 장애 모드",
      "subtitle": "웹사이트 시각적 표현을 향상시킵니다",
      "description": "이 모드는 시각 장애, 시야 제한, 백내장, 녹내장 등 시각 장애를 가진 사용자들을 위한 웹 사이트를 편리하게 조정합니다."
    },
    "cognitive_disability": {
      "title": "인지 장애 모드",
      "subtitle": "특정 콘텐츠에 집중하는 데 도움을 줍니다",
      "description": "이 모드는 인지 장애인(실해, 자폐증, 뇌졸중 등) 사용자들이 웹 사이트의 중요한 요소에 쉽게 집중할 수 있도록 다양한 지원 옵션을 제공합니다."
    },
    "adhd_friendly": {
      "title": "ADHD 친화적 모드",
      "subtitle": "주의력 산만을 감소시키고 집중력을 향상시킵니다",
      "description": "이 모드는 ADHD와 신경 발달 장애를 가진 사용자들이 주요 웹 사이트 요소를 쉽게 읽고 탐색하며 주요한 분산을 크게 감소시킬 수 있도록 도와줍니다."
    },
    "blindness": {
      "title": "장애인 모드",
      "subtitle": "스크린 리더를 사용하여 사이트 이용을 허용합니다",
      "description": "이 모드는 JAWS, NVDA, VoiceOver, TalkBack과 같은 스크린 리더와 호환되도록 웹 사이트를 구성합니다. 스크린 리더는 시각 장애인을 위한 컴퓨터와 스마트폰에 설치된 소프트웨어로, 웹 사이트는 이와 호환되어야 합니다."
    },
    "search_wikipedia_dictionary": {
      "text": "위키피디아 사전 검색"
    }
  },
  "mandarin_chinese": {
    "widget": {
      "text": "无障碍菜单"
    },
    "reset_button": {
      "text": "重置"
    },
    "hide_button": {
      "text": "隐藏"
    },
    "mute_sound": {
      "text": "静音"
    },
    "hide_image": {
      "text": "隐藏图片"
    },
    "virtual_keyboard": {
      "text": "虚拟键盘"
    },
    "reading_guide": {
      "text": "阅读指南"
    },
    "reading_mask": {
      "text": "阅读遮罩"
    },
    "stop_animation": {
      "text": "停止动画"
    },
    "highlight_hover": {
      "text": "鼠标悬停高亮"
    },
    "highlight_focus": {
      "text": "焦点高亮"
    },
    "black_cursor": {
      "text": "大黑色光标"
    },
    "white_cursor": {
      "text": "大白色光标"
    },
    "navigation_keys": {
      "text": "导航键"
    },
    "tts": {
      "text": "文本到语音"
    },
    "content_scaling": {
      "text": "内容缩放"
    },
    "font_sizing": {
      "text": "字体大小"
    },
    "line_height": {
      "text": "行高"
    },
    "letter_spacing": {
      "text": "字母间距"
    },
    "text_magnifier": {
      "text": "文本放大器"
    },
    "readable_font": {
      "text": "可读字体"
    },
    "dyslexia_friendly": {
      "text": "阅读困难友好"
    },
    "highlight_titles": {
      "text": "标题高亮"
    },
    "highlight_links": {
      "text": "链接高亮"
    },
    "center_aligned": {
      "text": "居中对齐"
    },
    "left_aligned": {
      "text": "左对齐"
    },
    "right_aligned": {
      "text": "右对齐"
    },
    "dark_contrast": {
      "text": "深色对比度"
    },
    "light_contrast": {
      "text": "浅色对比度"
    },
    "monochrome": {
      "text": "单色"
    },
    "high_contrast": {
      "text": "高对比度"
    },
    "high_saturation": {
      "text": "高饱和度"
    },
    "low_saturation": {
      "text": "低饱和度"
    },
    "adjust_text_color": {
      "text": "调整文字颜色"
    },
    "adjust_title_color": {
      "text": "调整标题颜色"
    },
    "adjust_background_color": {
      "text": "调整背景颜色"
    },
    "default": {
      "text": "默认"
    },
    "off": {
      "text": "关闭"
    },
    "on": {
      "text": "开启"
    },
    "epilepsy": {
      "title": "癫痫安全模式",
      "subtitle": "减轻颜色并消除闪烁",
      "description": "该模式可让癫痫患者安全使用网站，消除由闪烁动画或危险的颜色组合引发的癫痫发作风险。"
    },
    "visually_impaired": {
      "title": "视觉障碍者模式",
      "subtitle": "改善网站的视觉效果",
      "description": "该模式调整网站以适应视觉障碍者，如视力下降、视野狭窄、白内障、青光眼等，以提供更加舒适的体验。"
    },
    "cognitive_disability": {
      "title": "认知障碍者模式",
      "subtitle": "帮助专注于特定内容",
      "description": "该模式提供不同的辅助选项，帮助认知障碍者，如阅读障碍、自闭症、脑卒中等，更容易专注于网站的关键元素。"
    },
    "adhd_friendly": {
      "title": "ADHD友好模式",
      "subtitle": "减少干扰，提高注意力",
      "description": "该模式帮助ADHD和神经发育障碍患者更容易阅读、浏览和专注于网站的主要元素，显著减少干扰。"
    },
    "blindness": {
      "title": "盲人模式",
      "subtitle": "允许使用屏幕阅读器",
      "description": "该模式配置网站以与JAWS、NVDA、VoiceOver和TalkBack等屏幕阅读器兼容。屏幕阅读器是安装在计算机和智能手机上的盲人用户的软件，网站必须与之兼容。"
    },
    "search_wikipedia_dictionary": {
      "text": "搜索维基百科词典"
    }
  },
  "polish": {
    "widget": {
      "text": "Menu dostępności"
    },
    "reset_button": {
      "text": "Resetuj"
    },
    "hide_button": {
      "text": "Ukryj"
    },
    "mute_sound": {
      "text": "Wycisz dźwięk"
    },
    "hide_image": {
      "text": "Ukryj obrazy"
    },
    "virtual_keyboard": {
      "text": "Klawiatura wirtualna"
    },
    "reading_guide": {
      "text": "Przewodnik czytania"
    },
    "reading_mask": {
      "text": "Maska czytania"
    },
    "stop_animation": {
      "text": "Zatrzymaj animacje"
    },
    "highlight_hover": {
      "text": "Podświetl najechanie"
    },
    "highlight_focus": {
      "text": "Podświetl fokus"
    },
    "black_cursor": {
      "text": "Duży czarny kursor"
    },
    "white_cursor": {
      "text": "Duży biały kursor"
    },
    "navigation_keys": {
      "text": "Klawisze nawigacyjne"
    },
    "tts": {
      "text": "Tekst na mowę"
    },
    "content_scaling": {
      "text": "Skalowanie treści"
    },
    "font_sizing": {
      "text": "Zmiana rozmiaru czcionki"
    },
    "line_height": {
      "text": "Interlinia"
    },
    "letter_spacing": {
      "text": "Odstępy między literami"
    },
    "text_magnifier": {
      "text": "Lupa tekstu"
    },
    "readable_font": {
      "text": "Czytelna czcionka"
    },
    "dyslexia_friendly": {
      "text": "Przyjazne dla dyslektyków"
    },
    "highlight_titles": {
      "text": "Podświetl tytuły"
    },
    "highlight_links": {
      "text": "Podświetl linki"
    },
    "center_aligned": {
      "text": "Wyśrodkowane"
    },
    "left_aligned": {
      "text": "Wyrównane do lewej"
    },
    "right_aligned": {
      "text": "Wyrównane do prawej"
    },
    "dark_contrast": {
      "text": "Ciemny kontrast"
    },
    "light_contrast": {
      "text": "Jasny kontrast"
    },
    "monochrome": {
      "text": "Monochromatyczne"
    },
    "high_contrast": {
      "text": "Wysoki kontrast"
    },
    "high_saturation": {
      "text": "Wysoka nasycenie"
    },
    "low_saturation": {
      "text": "Niska nasycenie"
    },
    "adjust_text_color": {
      "text": "Dostosuj kolor tekstu"
    },
    "adjust_title_color": {
      "text": "Dostosuj kolory tytułów"
    },
    "adjust_background_color": {
      "text": "Dostosuj kolory tła"
    },
    "default": {
      "text": "Domyślne"
    },
    "off": {
      "text": "WYŁĄCZONE"
    },
    "on": {
      "text": "WŁĄCZONE"
    },
    "epilepsy": {
      "title": "Tryb Bezpieczeństwa Dla Epileptyków",
      "subtitle": "Wycisza kolory i usuwa migotanie",
      "description": "Ten tryb pozwala osobom cierpiącym na epilepsję na bezpieczne korzystanie z witryny, eliminując ryzyko napadów wywołanych migoczącymi animacjami i ryzykownymi kombinacjami kolorów."
    },
    "visually_impaired": {
      "title": "Tryb Dla Osób z Upośledzeniem Wzroku",
      "subtitle": "Poprawia wizualizację witryny",
      "description": "Ten tryb dostosowuje witrynę, aby była wygodna dla użytkowników z upośledzeniem wzroku, takich jak upośledzenie wzroku, zwężone pole widzenia, zaćma, jaskra i inne."
    },
    "cognitive_disability": {
      "title": "Tryb Dla Osób z Upośledzeniem Poznawczym",
      "subtitle": "Pomaga w skoncentrowaniu się na konkretnych treściach",
      "description": "Ten tryb oferuje różne opcje wspomagające, aby pomóc użytkownikom z upośledzeniem poznawczym, takim jak dysleksja, autyzm, udar mózgu (CVA) i innym, w łatwiejszym skoncentrowaniu się na istotnych elementach witryny."
    },
    "adhd_friendly": {
      "title": "Tryb Przyjazny Dla Osób z ADHD",
      "subtitle": "Zmniejsza rozproszenia i poprawia koncentrację",
      "description": "Ten tryb pomaga użytkownikom z ADHD i zaburzeniami neurologicznego rozwoju w łatwiejszym czytaniu, przeglądaniu i koncentrowaniu się na głównych elementach witryny, znacząco redukując rozproszenia."
    },
    "blindness": {
      "title": "Tryb Dla Niewidomych",
      "subtitle": "Pozwala na korzystanie z witryny za pomocą czytnika ekranu",
      "description": "Ten tryb konfiguruje witrynę tak, aby była kompatybilna z czytnikami ekranu, takimi jak JAWS, NVDA, VoiceOver i TalkBack. Czytnik ekranu to oprogramowanie dla niewidomych użytkowników, zainstalowane na komputerach i smartfonach, a witryny muszą być z nim kompatybilne."
    },
    "search_wikipedia_dictionary": {
      "text": "Wyszukaj słownik Wikipedii"
    }
  },
  "portuguese": {
    "widget": {
      "text": "Menu de Acessibilidade"
    },
    "reset_button": {
      "text": "Reiniciar"
    },
    "hide_button": {
      "text": "Ocultar"
    },
    "mute_sound": {
      "text": "Silenciar Sons"
    },
    "hide_image": {
      "text": "Ocultar Imagens"
    },
    "virtual_keyboard": {
      "text": "Teclado Virtual"
    },
    "reading_guide": {
      "text": "Guia de Leitura"
    },
    "reading_mask": {
      "text": "Máscara de Leitura"
    },
    "stop_animation": {
      "text": "Parar Animações"
    },
    "highlight_hover": {
      "text": "Realçar ao Passar o Mouse"
    },
    "highlight_focus": {
      "text": "Realçar com Foco"
    },
    "black_cursor": {
      "text": "Cursor Grande Preto"
    },
    "white_cursor": {
      "text": "Cursor Grande Branco"
    },
    "navigation_keys": {
      "text": "Teclas de Navegação"
    },
    "tts": {
      "text": "Texto para Fala"
    },
    "content_scaling": {
      "text": "Redimensionar Conteúdo"
    },
    "font_sizing": {
      "text": "Tamanho da Fonte"
    },
    "line_height": {
      "text": "Espaçamento entre Linhas"
    },
    "letter_spacing": {
      "text": "Espaçamento entre Letras"
    },
    "text_magnifier": {
      "text": "Lupa de Texto"
    },
    "readable_font": {
      "text": "Fonte Legível"
    },
    "dyslexia_friendly": {
      "text": "Amigável para Dislexia"
    },
    "highlight_titles": {
      "text": "Realçar Títulos"
    },
    "highlight_links": {
      "text": "Realçar Links"
    },
    "center_aligned": {
      "text": "Alinhado ao Centro"
    },
    "left_aligned": {
      "text": "Alinhado à Esquerda"
    },
    "right_aligned": {
      "text": "Alinhado à Direita"
    },
    "dark_contrast": {
      "text": "Contraste Escuro"
    },
    "light_contrast": {
      "text": "Contraste Claro"
    },
    "monochrome": {
      "text": "Monocromático"
    },
    "high_contrast": {
      "text": "Alto Contraste"
    },
    "high_saturation": {
      "text": "Alta Saturação"
    },
    "low_saturation": {
      "text": "Baixa Saturação"
    },
    "adjust_text_color": {
      "text": "Ajustar Cor do Texto"
    },
    "adjust_title_color": {
      "text": "Ajustar Cores dos Títulos"
    },
    "adjust_background_color": {
      "text": "Ajustar Cores de Fundo"
    },
    "default": {
      "text": "Padrão"
    },
    "off": {
      "text": "Desligado"
    },
    "on": {
      "text": "Ligado"
    },
    "epilepsy": {
      "title": "Modo Seguro para Epilepsia",
      "subtitle": "Reduz cores e elimina cintilações",
      "description": "Este modo permite que pessoas com epilepsia usem o site com segurança, eliminando o risco de convulsões decorrentes de animações piscantes ou combinações de cores arriscadas."
    },
    "visually_impaired": {
      "title": "Modo para Deficientes Visuais",
      "subtitle": "Melhora a apresentação do site",
      "description": "Este modo ajusta o site para a comodidade de usuários com deficiências visuais, como diminuição da visão, visão de túnel, catarata, glaucoma e outros."
    },
    "cognitive_disability": {
      "title": "Modo para Deficiência Cognitiva",
      "subtitle": "Ajuda a focar em conteúdo específico",
      "description": "Este modo oferece várias opções de assistência para ajudar usuários com deficiências cognitivas, como dislexia, autismo, AVC e outros, a se concentrarem mais facilmente nos elementos essenciais do site."
    },
    "adhd_friendly": {
      "title": "Modo Amigável para TDAH",
      "subtitle": "Reduz distrações e melhora o foco",
      "description": "Este modo ajuda usuários com TDAH e distúrbios do desenvolvimento a ler, navegar e focar nos principais elementos do site com mais facilidade, reduzindo significativamente as distrações."
    },
    "blindness": {
      "title": "Modo para Cegueira",
      "subtitle": "Permite usar o site com leitor de tela",
      "description": "Este modo configura o site para ser compatível com leitores de tela como JAWS, NVDA, VoiceOver e TalkBack. Um leitor de tela é um software para usuários cegos instalado em computadores e smartphones, e os sites devem ser compatíveis com ele."
    },
    "search_wikipedia_dictionary": {
      "text": "Pesquisar Dicionário da Wikipedia"
    }
  },
  "russian": {
    "widget": {
      "text": "Меню доступности"
    },
    "reset_button": {
      "text": "Сброс"
    },
    "hide_button": {
      "text": "Скрыть"
    },
    "mute_sound": {
      "text": "Отключить звук"
    },
    "hide_image": {
      "text": "Скрыть изображения"
    },
    "virtual_keyboard": {
      "text": "Виртуальная клавиатура"
    },
    "reading_guide": {
      "text": "Руководство по чтению"
    },
    "reading_mask": {
      "text": "Маска для чтения"
    },
    "stop_animation": {
      "text": "Остановить анимацию"
    },
    "highlight_hover": {
      "text": "Выделить при наведении"
    },
    "highlight_focus": {
      "text": "Выделить при фокусе"
    },
    "black_cursor": {
      "text": "Большая черная стрелка"
    },
    "white_cursor": {
      "text": "Большая белая стрелка"
    },
    "navigation_keys": {
      "text": "Клавиши навигации"
    },
    "tts": {
      "text": "Текст в речь"
    },
    "content_scaling": {
      "text": "Масштабирование контента"
    },
    "font_sizing": {
      "text": "Размер шрифта"
    },
    "line_height": {
      "text": "Межстрочный интервал"
    },
    "letter_spacing": {
      "text": "Межбуквенный интервал"
    },
    "text_magnifier": {
      "text": "Увеличение текста"
    },
    "readable_font": {
      "text": "Читаемый шрифт"
    },
    "dyslexia_friendly": {
      "text": "Дружелюбный к дислексии"
    },
    "highlight_titles": {
      "text": "Выделить заголовки"
    },
    "highlight_links": {
      "text": "Выделить ссылки"
    },
    "center_aligned": {
      "text": "По центру"
    },
    "left_aligned": {
      "text": "По левому краю"
    },
    "right_aligned": {
      "text": "По правому краю"
    },
    "dark_contrast": {
      "text": "Темный контраст"
    },
    "light_contrast": {
      "text": "Светлый контраст"
    },
    "monochrome": {
      "text": "Монохромный"
    },
    "high_contrast": {
      "text": "Высокий контраст"
    },
    "high_saturation": {
      "text": "Высокая насыщенность"
    },
    "low_saturation": {
      "text": "Низкая насыщенность"
    },
    "adjust_text_color": {
      "text": "Настройка цвета текста"
    },
    "adjust_title_color": {
      "text": "Настройка цветов заголовков"
    },
    "adjust_background_color": {
      "text": "Настройка цветов фона"
    },
    "default": {
      "text": "По умолчанию"
    },
    "off": {
      "text": "Выключено"
    },
    "on": {
      "text": "Включено"
    },
    "epilepsy": {
      "title": "Режим безопасности для эпилепсии",
      "subtitle": "Подавляет цвета и устраняет мерцание",
      "description": "Этот режим позволяет людям с эпилепсией использовать веб-сайт безопасно, исключая риск припадков, вызванных мигающими анимациями и опасными комбинациями цветов."
    },
    "visually_impaired": {
      "title": "Режим для лиц с ограниченными возможностями зрения",
      "subtitle": "Улучшает визуализацию веб-сайта",
      "description": "Этот режим настраивает веб-сайт для удобства пользователей с ограниченными возможностями зрения, такими как снижение зрения, туннельное зрение, катаракта, глаукома и другие."
    },
    "cognitive_disability": {
      "title": "Режим для лиц с когнитивными нарушениями",
      "subtitle": "Помогает сосредоточиться на конкретном контенте",
      "description": "Этот режим предоставляет различные варианты помощи для пользователей с когнитивными нарушениями, такими как дислексия, аутизм, цереброваскулярное заболевание и другие, чтобы они могли легче сосредотачиваться на важных элементах веб-сайта."
    },
    "adhd_friendly": {
      "title": "Режим для лиц с СДВГ (Синдром Дефицита Внимания и Гиперактивности)",
      "subtitle": "Снижает отвлечения и повышает концентрацию",
      "description": "Этот режим помогает пользователям с СДВГ и неврологическими нарушениями читать, просматривать и сосредотачиваться на основных элементах веб-сайта с большей легкостью, значительно уменьшая отвлечения."
    },
    "blindness": {
      "title": "Режим для слепых",
      "subtitle": "Позволяет использовать сайт с помощью программ для чтения экрана",
      "description": "Этот режим настраивает веб-сайт для совместимости с программами для чтения экрана, такими как JAWS, NVDA, VoiceOver и TalkBack. Программа для чтения экрана - это программное обеспечение для слепых пользователей, установленное на компьютерах и смартфонах, и сайты должны быть совместимы с ней."
    },
    "search_wikipedia_dictionary": {
      "text": "Поиск в словаре Википедии"
    }
  },
  "spanish": {
    "widget": {
      "text": "Menú de accesibilidad"
    },
    "reset_button": {
      "text": "Restablecer"
    },
    "hide_button": {
      "text": "Ocultar"
    },
    "mute_sound": {
      "text": "Silenciar sonidos"
    },
    "hide_image": {
      "text": "Ocultar imágenes"
    },
    "virtual_keyboard": {
      "text": "Teclado virtual"
    },
    "reading_guide": {
      "text": "Guía de lectura"
    },
    "reading_mask": {
      "text": "Máscara de lectura"
    },
    "stop_animation": {
      "text": "Detener animaciones"
    },
    "highlight_hover": {
      "text": "Resaltar al pasar el cursor"
    },
    "highlight_focus": {
      "text": "Resaltar enfoque"
    },
    "black_cursor": {
      "text": "Cursor grande negro"
    },
    "white_cursor": {
      "text": "Cursor grande blanco"
    },
    "navigation_keys": {
      "text": "Teclas de navegación"
    },
    "tts": {
      "text": "Texto a voz"
    },
    "content_scaling": {
      "text": "Escalado de contenido"
    },
    "font_sizing": {
      "text": "Tamaño de fuente"
    },
    "line_height": {
      "text": "Espaciado de línea"
    },
    "letter_spacing": {
      "text": "Espaciado de letras"
    },
    "text_magnifier": {
      "text": "Lupa de texto"
    },
    "readable_font": {
      "text": "Fuente legible"
    },
    "dyslexia_friendly": {
      "text": "Amigable para dislexia"
    },
    "highlight_titles": {
      "text": "Resaltar títulos"
    },
    "highlight_links": {
      "text": "Resaltar enlaces"
    },
    "center_aligned": {
      "text": "Centrar alineación"
    },
    "left_aligned": {
      "text": "Alineado a la izquierda"
    },
    "right_aligned": {
      "text": "Alineado a la derecha"
    },
    "dark_contrast": {
      "text": "Contraste oscuro"
    },
    "light_contrast": {
      "text": "Contraste claro"
    },
    "monochrome": {
      "text": "Monocromo"
    },
    "high_contrast": {
      "text": "Alto contraste"
    },
    "high_saturation": {
      "text": "Alta saturación"
    },
    "low_saturation": {
      "text": "Baja saturación"
    },
    "adjust_text_color": {
      "text": "Ajustar color del texto"
    },
    "adjust_title_color": {
      "text": "Ajustar colores de títulos"
    },
    "adjust_background_color": {
      "text": "Ajustar colores de fondo"
    },
    "default": {
      "text": "Predeterminado"
    },
    "off": {
      "text": "APAGADO"
    },
    "on": {
      "text": "ENCENDIDO"
    },
    "epilepsy": {
      "title": "Modo Seguro para Epilepsia",
      "subtitle": "Atenúa colores y elimina destellos",
      "description": "Este modo permite a las personas con epilepsia utilizar el sitio web de forma segura, eliminando el riesgo de convulsiones causadas por animaciones parpadeantes o combinaciones de colores arriesgadas."
    },
    "visually_impaired": {
      "title": "Modo para Personas con Discapacidad Visual",
      "subtitle": "Mejora la presentación del sitio web",
      "description": "Este modo ajusta el sitio web para la comodidad de los usuarios con discapacidades visuales, como la disminución de la vista, la visión en túnel, las cataratas, el glaucoma y otros."
    },
    "cognitive_disability": {
      "title": "Modo para Discapacidad Cognitiva",
      "subtitle": "Ayuda a enfocarse en contenido específico",
      "description": "Este modo ofrece diferentes opciones de asistencia para ayudar a los usuarios con discapacidades cognitivas, como la dislexia, el autismo, el accidente cerebrovascular (ACV) y otros, a enfocarse más fácilmente en los elementos esenciales del sitio web."
    },
    "adhd_friendly": {
      "title": "Modo Amigable para el TDAH",
      "subtitle": "Reduce las distracciones y mejora la concentración",
      "description": "Este modo ayuda a los usuarios con TDAH y trastornos del neurodesarrollo a leer, navegar y enfocarse en los elementos principales del sitio web con mayor facilidad, reduciendo significativamente las distracciones."
    },
    "blindness": {
      "title": "Modo para Ciegos",
      "subtitle": "Permite utilizar el sitio con un lector de pantalla",
      "description": "Este modo configura el sitio web para que sea compatible con lectores de pantalla como JAWS, NVDA, VoiceOver y TalkBack. Un lector de pantalla es un software instalado en computadoras y teléfonos inteligentes para usuarios ciegos, y los sitios web deben ser compatibles con él."
    },
    "search_wikipedia_dictionary": {
      "text": "Buscar en el diccionario de Wikipedia"
    }
  },
  "turkish": {
    "widget": {
      "text": "Erişilebilirlik Menüsü"
    },
    "reset_button": {
      "text": "Sıfırla"
    },
    "hide_button": {
      "text": "Gizle"
    },
    "mute_sound": {
      "text": "Sesleri Kapat"
    },
    "hide_image": {
      "text": "Resimleri Gizle"
    },
    "virtual_keyboard": {
      "text": "Sanal Klavye"
    },
    "reading_guide": {
      "text": "Okuma Rehberi"
    },
    "reading_mask": {
      "text": "Okuma Maske"
    },
    "stop_animation": {
      "text": "Animasyonları Durdur"
    },
    "highlight_hover": {
      "text": "Üzerine Gelindiğinde Vurgula"
    },
    "highlight_focus": {
      "text": "Odaklandığında Vurgula"
    },
    "black_cursor": {
      "text": "Büyük Siyah İmleç"
    },
    "white_cursor": {
      "text": "Büyük Beyaz İmleç"
    },
    "navigation_keys": {
      "text": "Gezinme Tuşları"
    },
    "tts": {
      "text": "Metni Sese Dönüştür"
    },
    "content_scaling": {
      "text": "İçeriği Ölçekleme"
    },
    "font_sizing": {
      "text": "Yazı Tipi Boyutu"
    },
    "line_height": {
      "text": "Satır Aralığı"
    },
    "letter_spacing": {
      "text": "Harf Aralığı"
    },
    "text_magnifier": {
      "text": "Metin Büyüteci"
    },
    "readable_font": {
      "text": "Okunabilir Yazı"
    },
    "dyslexia_friendly": {
      "text": "Disleksi Dostu"
    },
    "highlight_titles": {
      "text": "Başlıkları Vurgula"
    },
    "highlight_links": {
      "text": "Bağlantıları Vurgula"
    },
    "center_aligned": {
      "text": "Ortala"
    },
    "left_aligned": {
      "text": "Sola Hizala"
    },
    "right_aligned": {
      "text": "Sağa Hizala"
    },
    "dark_contrast": {
      "text": "Koyu Kontrast"
    },
    "light_contrast": {
      "text": "Açık Kontrast"
    },
    "monochrome": {
      "text": "Monokrom"
    },
    "high_contrast": {
      "text": "Yüksek Kontrast"
    },
    "high_saturation": {
      "text": "Yüksek Doygunluk"
    },
    "low_saturation": {
      "text": "Düşük Doygunluk"
    },
    "adjust_text_color": {
      "text": "Metin Rengini Ayarla"
    },
    "adjust_title_color": {
      "text": "Başlık Renklerini Ayarla"
    },
    "adjust_background_color": {
      "text": "Arka Plan Renklerini Ayarla"
    },
    "default": {
      "text": "Varsayılan"
    },
    "off": {
      "text": "KAPALI"
    },
    "on": {
      "text": "AÇIK"
    },
    "epilepsy": {
      "title": "Epilepsi Güvenli Mod",
      "subtitle": "Renkleri hafifletir ve yanıp sönme efektini kaldırır",
      "description": "Bu mod, epilepsi hastalarının, flaş veya yanıp sönme animasyonlarından veya riskli renk kombinasyonlarından kaynaklanan nöbetlerin riskini ortadan kaldırarak web sitesini güvenli bir şekilde kullanmalarına olanak tanır."
    },
    "visually_impaired": {
      "title": "Görme Engelli Modu",
      "subtitle": "Web sitesinin görsel görünümünü iyileştirir",
      "description": "Bu mod, görme engelli, görüş daralması, katarakt, glokom ve diğer görme engelleri olan kullanıcılar için web sitesini uygun hale getirir."
    },
    "cognitive_disability": {
      "title": "Bilişsel Engelliler Modu",
      "subtitle": "Belirli içeriklere odaklanmaya yardımcı olur",
      "description": "Bu mod, disleksi, otizm, inme (felç) ve diğer bilişsel engellere sahip kullanıcılara web sitesinin temel unsurlarına daha kolay odaklanmalarına yardımcı olacak çeşitli destek seçenekleri sunar."
    },
    "adhd_friendly": {
      "title": "Dikkat Eksikliği ve Hiperaktivite Bozukluğu (DEHB) Dostu Modu",
      "subtitle": "Dikkat dağıtıcıları azaltır ve odaklanmayı artırır",
      "description": "Bu mod, DEHB ve nörogelişimsel bozukluklara sahip kullanıcıların web sitesinin temel unsurlarını daha kolay okumalarına, gezinmelerine ve odaklanmalarına yardımcı olurken dikkat dağıtıcıları önemli ölçüde azaltır."
    },
    "blindness": {
      "title": "Körler Modu",
      "subtitle": "Ekran okuyucusu ile siteyi kullanmaya olanak tanır",
      "description": "Bu mod, JAWS, NVDA, VoiceOver ve TalkBack gibi ekran okuyucuları ile uyumlu hale getirmek için web sitesini yapılandırır. Ekran okuyucusu, bilgisayarlar ve akıllı telefonlara kurulan kör kullanıcılar için bir yazılımdır ve web siteleri onunla uyumlu olmalıdır."
    },
    "search_wikipedia_dictionary": {
      "text": "Wikipedia Sözlüğünde Ara"
    }
  },
  "vietnamese": {
    "widget": {
      "text": "Menu Truy cập"
    },
    "reset_button": {
      "text": "Thiết lập lại"
    },
    "hide_button": {
      "text": "Ẩn"
    },
    "mute_sound": {
      "text": "Tắt Âm thanh"
    },
    "hide_image": {
      "text": "Ẩn Hình ảnh"
    },
    "virtual_keyboard": {
      "text": "Bàn phím ảo"
    },
    "reading_guide": {
      "text": "Hướng dẫn Đọc"
    },
    "reading_mask": {
      "text": "Mặt nạ Đọc"
    },
    "stop_animation": {
      "text": "Dừng Hiệu ứng"
    },
    "highlight_hover": {
      "text": "Nhấn mạnh khi di chuột"
    },
    "highlight_focus": {
      "text": "Nhấn mạnh Focus"
    },
    "black_cursor": {
      "text": "Con trỏ Đen Lớn"
    },
    "white_cursor": {
      "text": "Con trỏ Trắng Lớn"
    },
    "navigation_keys": {
      "text": "Phím Điều hướng"
    },
    "tts": {
      "text": "Chuyển đổi Văn bản thành Tiếng nói"
    },
    "content_scaling": {
      "text": "Tăng/Giảm Kích thước Nội dung"
    },
    "font_sizing": {
      "text": "Cỡ chữ"
    },
    "line_height": {
      "text": "Khoảng cách dòng"
    },
    "letter_spacing": {
      "text": "Khoảng cách ký tự"
    },
    "text_magnifier": {
      "text": "Kính lúp Văn bản"
    },
    "readable_font": {
      "text": "Phông chữ Dễ đọc"
    },
    "dyslexia_friendly": {
      "text": "Thân thiện với Người khuyết Điểm Về Đọc"
    },
    "highlight_titles": {
      "text": "Nhấn mạnh Tiêu đề"
    },
    "highlight_links": {
      "text": "Nhấn mạnh Liên kết"
    },
    "center_aligned": {
      "text": "Căn giữa"
    },
    "left_aligned": {
      "text": "Căn trái"
    },
    "right_aligned": {
      "text": "Căn phải"
    },
    "dark_contrast": {
      "text": "Tương phản Tối"
    },
    "light_contrast": {
      "text": "Tương phản Sáng"
    },
    "monochrome": {
      "text": "Màu đơn sắc"
    },
    "high_contrast": {
      "text": "Tương phản Cao"
    },
    "high_saturation": {
      "text": "Bão hòa Cao"
    },
    "low_saturation": {
      "text": "Bão hòa Thấp"
    },
    "adjust_text_color": {
      "text": "Điều chỉnh Màu văn bản"
    },
    "adjust_title_color": {
      "text": "Điều chỉnh Màu Tiêu đề"
    },
    "adjust_background_color": {
      "text": "Điều chỉnh Màu Nền"
    },
    "default": {
      "text": "Mặc định"
    },
    "off": {
      "text": "TẮT"
    },
    "on": {
      "text": "BẬT"
    },
    "epilepsy": {
      "title": "Chế độ An toàn cho Người bị Động kinh",
      "subtitle": "Làm mờ màu sắc và loại bỏ hiệu ứng nhấp nháy",
      "description": "Chế độ này cho phép những người mắc bệnh động kinh sử dụng trang web một cách an toàn bằng cách loại bỏ nguy cơ mắc cơn động kinh do các hoạt hình nhấp nháy hoặc sự kết hợp màu sắc nguy hiểm gây ra."
    },
    "visually_impaired": {
      "title": "Chế độ cho Người mắc Bệnh Thị lực Yếu",
      "subtitle": "Cải thiện giao diện trang web",
      "description": "Chế độ này điều chỉnh trang web để phục vụ sự thoải mái của người dùng mắc bệnh thị lực yếu, chẳng hạn như sự suy giảm thị lực, tầm nhìn hẹp, đục thủy tinh thể, bệnh tăng nhãn áp và các vấn đề khác."
    },
    "cognitive_disability": {
      "title": "Chế độ cho Người mắc Bệnh Về Trí tuệ",
      "subtitle": "Hỗ trợ tập trung vào nội dung cụ thể",
      "description": "Chế độ này cung cấp các tùy chọn hỗ trợ khác nhau để giúp người dùng mắc bệnh về trí tuệ, chẳng hạn như rối loạn đọc viết, tự kỷ, đột quỵ (CVA) và các vấn đề khác, dễ dàng tập trung vào các yếu tố cốt lõi của trang web."
    },
    "adhd_friendly": {
      "title": "Chế độ Thân thiện với TDAH",
      "subtitle": "Giảm xao lạc và cải thiện tập trung",
      "description": "Chế độ này giúp người dùng mắc rối loạn tăng động và các rối loạn phát triển thần kinh đọc, duyệt và tập trung vào các yếu tố chính của trang web một cách dễ dàng hơn và giảm đáng kể xao lạc."
    },
    "blindness": {
      "title": "Chế độ cho Người mù",
      "subtitle": "Cho phép sử dụng trang web với trình đọc màn hình",
      "description": "Chế độ này cấu hình trang web để tương thích với trình đọc màn hình như JAWS, NVDA, VoiceOver và TalkBack. Trình đọc màn hình là phần mềm dành cho người mù được cài đặt trên máy tính và điện thoại thông minh, và trang web phải tương thích với nó."
    },
    "search_wikipedia_dictionary": {
      "text": "Tìm kiếm từ điển Wikipedia"
    }
  }
}